<template>
  <div>
      <div class="columns is-multiline">
        <div
          v-for="(post, index) in posts"
          :key="post.id"
          class="column is-one-third"
        >
          <ArticlesItem :post="post" :index="index" :thumbnailPlaceholderUrl="thumbnailPlaceholderUrl"></ArticlesItem>
        </div>
      </div>

    <div v-if="showLoadMore" id="more-2" class="more-component">
      <div class="animation-line"></div>
    </div>

    <div v-if="showLoadMore">
      <a 
        tabindex="0"
        @click="loadMore"
        class="btn-vue grid-x align-center-middle u-margin-bottom-big article-more"
      >Näytä lisää</a>
    </div>

    <div class="vue-buffer" v-if="!showLoadMore"></div>
  </div>
</template>

<script>
import ArticlesItem from "./ArticlesItem";

export default {
  components: {
    ArticlesItem
  },
  props: {
    thumbnailPlaceholderUrl: {},
    postsPerPage: { type: Number, default: 500 },
    frontpage: { type: Boolean, default: false },
  },
  data() {
    return {
      posts: [],
      offset: 0,
      showLoadMore: true,
      queryBase: window.BASE_URL + "/wp-json/wp/v2/"
    };
  },
  mounted: function() {
    this.listingType = this.$el.getAttribute("data-posttype");
    Promise.all([this.fetchPosts(this.postQuery), this.fetchPosts(this.mainPostQuery)]).then(([postData, mainPostData]) => {
      mainPostData = mainPostData.map(post => {
        post.external = true;
        return post;
      });

      let newPosts = [...postData, ...mainPostData];
      this.posts = this.createPosts(newPosts);

      if(this.frontpage) {
        this.posts = this.posts.slice(0, this.postsPerPage);
      }
    });
  },
  watch: {},
  computed: {
    mainSiteQueryBase() {
      return window.MAIN_SITE_BASE_URL + "/";
      let base = this.queryBase.split('//');
      let url = base[1].split('.');
      return base[0] + '//' + url[1] + '.' + url[2];
    },
    postQuery() {
      let query =
        this.queryBase +
        this.listingType +
        "?per_page=" +
        this.postsPerPage +
        "&" +
        "exclude=0" +
        "&offset=" +
        this.offset +
        "&_embed";
      return query;
    },
    mainPostQuery() {
      let query =
        window.BASE_URL +
        "/wp-json/parent/" +
        this.listingType +
        "?per_page=" +
        this.postsPerPage +
        "&" +
        "exclude=0" +
        "&offset=" +
        this.offset;
      return query;
    },
    perPage() {
      return this.postsPerPage;
    }
  },
  methods: {
    createPosts(postData) {
      let posts = [];
      postData.forEach(post => {
        let simplePost = this.createPostObject(post);
        posts.push(simplePost);
      });

      posts.sort((a, b) => {
        if(a.date > b.date) {
          return -1;
        }
        if(b.date > a.date) {
          return 1;
        }
        return 0;
      });

      let externalStickies = posts.filter(post => {
        return post.sticky && post.external;
      });

      let internalStickies = posts.filter(post => {
        return post.sticky && !post.external;
      });

      posts = posts.filter(post => {
        return !post.sticky;
      });

      posts.unshift(...externalStickies);
      posts.unshift(...internalStickies);

      return posts;
    },
    createPostObject(post) {
      let altTxt = post._embedded['wp:featuredmedia'] ? post._embedded['wp:featuredmedia'][0].alt_text : "";
      let thumbnail = post._embedded['wp:featuredmedia'] ? post._embedded['wp:featuredmedia'][0].source_url : "";

      let link = post.link;
      if(post.external) {
        let linkEnd = post.link.split('/');
        linkEnd.splice(0, 3);
        linkEnd = linkEnd.join('/');
        link = window.BASE_URL + '/e/' + post.id + '/' + linkEnd;
      }

      return {
        id: post.id,
        url: link,
        thumbnail: thumbnail,
        alt: altTxt,
        date: post.date,
        excerpt: post.excerpt,
        title: post.title,
        link: link,
        sticky: post.sticky,
        external: post.external
      };
    },
    fetchPosts(query) {
      return fetch(query)
        .then(response => {
          let totalPosts = response.headers.get("X-WP-Total");
          this.showLoadMore =
            this.offset + this.postsPerPage < totalPosts ? true : false;
          return response.json();
        })
        .catch(error => console.error("error: " + error));
    },
    loadMore() {
      this.offset += this.postsPerPage;
      Promise.all([this.fetchPosts(this.postQuery), this.fetchPosts(this.mainPostQuery)]).then(([postData, mainPostData]) => {
        mainPostData = mainPostData.map(post => {
          post.external = true;
          return post;
        });

        let newPosts = [...postData, ...mainPostData];
        this.posts = this.posts.concat(this.createPosts(newPosts));
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-vue:focus {
  outline: 0;
}
.vue-buffer {
  margin-bottom: 4rem;
  width: 100%;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-leave-to, .list-enter /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-enter-to,
.list-leave {
  opacity: 1;
  transform: translateY(0);
}
a:focus{
    border: 1px solid;
}
</style>
